import React from "react";
import "./logo.css";

export default function Logo() {
  return <h1 className="logo">Luna Nationality</h1>;
}
